import { TRUST_ITEMS } from '../../mocks/sharedData';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

interface TrustBarProps {
  items?: typeof TRUST_ITEMS;
}

const TrustBar = ({ items = TRUST_ITEMS }: TrustBarProps) => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-zinc-950">
      {/* Star rating banner */}
      <div className="border-b border-zinc-800/60 bg-zinc-900/50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-4">
            <div className="flex">
              {Array(5).fill(null).map((_, i) => (
                <div key={i} className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-400 text-base" />
                </div>
              ))}
            </div>
            <span className="text-white font-semibold text-sm tracking-wide">5-Star Rated Solar Installer in Kentuckiana</span>
            <span className="hidden sm:block text-zinc-500 text-xs">· Google · Facebook</span>
          </div>
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-fill text-amber-400 text-sm" />
              </div>
              <span className="text-zinc-400 text-xs whitespace-nowrap">Licensed IN &amp; KY</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-verified-badge-fill text-amber-400 text-sm" />
              </div>
              <span className="text-zinc-400 text-xs whitespace-nowrap">Fully Insured</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-award-fill text-amber-400 text-sm" />
              </div>
              <span className="text-zinc-400 text-xs whitespace-nowrap">Est. 2015</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main trust items */}
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 py-12 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-1">
          {items.map((item, i) => (
            <div
              key={item.label}
              className={`flex flex-col items-center text-center px-4 py-6 rounded-2xl transition-all duration-700 hover:bg-zinc-900 group ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              } ${i < items.length - 1 ? '' : ''}`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center mb-4 bg-gradient-to-br from-amber-500/20 to-amber-600/5 rounded-2xl border border-amber-500/20 group-hover:border-amber-500/40 transition-colors">
                <i className={`${item.icon} text-amber-400 text-2xl`} />
              </div>
              <p className="text-white font-semibold text-sm leading-tight mb-1">{item.label}</p>
              <p className="text-zinc-500 text-xs">{item.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
